import {
  ButtonArrowState,
  Loader,
  PrimaryButton,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { interpolate } from 'utilities/interpolate';
import styles from './types.module.scss';

const Url = (props) => {
  const { loading = false, isBlueHuggg = false, vouchers } = props;

  const label = isBlueHuggg ? 'voucher' : 'gift card';

  const handleOnClick = () => {
    if (vouchers.length > 0) {
      window.location.href = vouchers[0].value;
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <PrimaryButton
          onClick={handleOnClick}
          data-test-id="button-voucher-external"
          label={interpolate(dictionary.openVoucher, '[type]', <>{label}</>)}
          arrow={ButtonArrowState.None}
          loading={loading}
          className={styles.fulfilButton}
        />
      )}
    </>
  );
};

Url.propTypes = {
  loading: PropTypes.bool,
  isBlueHuggg: PropTypes.bool,
  vouchers: PropTypes.array.isRequired,
};

export default Url;
